import { View } from "react-native";
import Button from "../../../components/Button";
import { TooltipCustom } from "../../../components/Tooltip";
import { Image } from "../style";

const ViewImage = (props) => {
    const { showModal, img, backgroundImage, orientation } = props;

    const horizontalImage = backgroundImage?.url || img;
    const verticalImage = backgroundImage?.urlVertical;

    const imageUri = horizontalImage ? horizontalImage : verticalImage ? verticalImage : null;

    const content = (
        <Image source={imageUri} resizeMode="cover">
            <View
                style={{
                    backgroundColor: "rgba(0,0,0,0.7)",
                    width: "100%",
                    height: "100%",
                    justifyContent: "center",
                }}
            >
                <View style={{ flexDirection: 'row', justifyContent: 'center', alignSelf: 'center' }}>
                    <Button
                        title={"Adicionar Capa Horizontal"}
                        onPress={() => showModal('horizontal')}
                        margin={"0.2rem"}
                    />
                    <TooltipCustom
                        iconColor={"white"}
                        text={"Recomedamos que a imagem tenha uma proporção de 16:9 para melhor visualização."}
                    />
                </View>
                {orientation === 'vertical' &&
                    <View style={{ flexDirection: 'row', justifyContent: 'center', alignSelf: 'center' }}>
                        <Button
                            title="Adicionar Capa Vertical"
                            onPress={() => showModal('vertical')}
                        />
                        <TooltipCustom
                            iconColor={"white"}
                            text={"A imagem em formato vertical será exibida na página inicial juntamente com todos os conteúdos disponíveis."}
                        />
                    </View>
                }
            </View>
        </Image>
    );

    return (
        <View
            style={{
                width: "100%",
                height: "100%",
                justifyContent: "center",
                borderRadius: 10,
                overflow: "hidden",
            }}
        >
            {content}
        </View>
    )
};

export default ViewImage;